export default "__VITE_ASSET__0b8c47jo__"